import { useCallback } from "react";
import { FileDropzone } from "./file-dropzone";

interface ImageDropzoneProps {
  onFilesSelect: (files: File[]) => void;
  multiple?: boolean;
  disabled?: boolean;
  accept?: string;
  className?: string;
}

export function ImageDropzone({
  onFilesSelect,
  multiple = false,
  disabled = false,
  accept = "image/*",
  className,
}: ImageDropzoneProps) {
  const handleFilesSelect = useCallback(
    (files: File[]) => {
      const imageFiles = files.filter((file) => file.type.startsWith("image/"));
      if (imageFiles.length > 0) {
        onFilesSelect(imageFiles);
      }
    },
    [onFilesSelect],
  );

  return (
    <FileDropzone
      onFilesSelect={handleFilesSelect}
      multiple={multiple}
      disabled={disabled}
      accept={accept}
      label={`Click or drag image${multiple ? "s" : ""} to upload`}
      dragLabel={`Drop image${multiple ? "s" : ""} here`}
      className={className}
    />
  );
}
